class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);

    /* Cart Properties Toggle — event delegation (handles AJAX re-renders) */
    this.addEventListener('click', function(e){
      var btn = e.target.closest('[data-cart-props-toggle]');
      if(!btn) return;

      var toggleDiv = btn.closest('.cart-props-toggle');
      if(!toggleDiv) return;
      var details = toggleDiv.nextElementSibling;
      if(!details || !details.hasAttribute('data-cart-props-details')) return;

      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if(isOpen){
        details.style.maxHeight = details.scrollHeight + 'px';
        details.offsetHeight;
        details.style.maxHeight = '0';
        details.style.opacity = '0';
        details.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        var text = btn.querySelector('[data-cart-props-text]');
        var count = details.querySelectorAll('.product-option').length;
        if(text) text.textContent = 'Voir les détails (+' + count + ')';
        setTimeout(function(){ details.style.display = 'none'; details.style.maxHeight = ''; details.style.opacity = ''; }, 300);
      } else {
        details.style.display = '';
        details.style.maxHeight = '0';
        details.style.opacity = '0';
        details.offsetHeight;
        details.style.maxHeight = details.scrollHeight + 'px';
        details.style.opacity = '1';
        details.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        var text2 = btn.querySelector('[data-cart-props-text]');
        if(text2) text2.textContent = 'Masquer les détails';
        setTimeout(function(){ details.style.maxHeight = ''; }, 300);
      }
    });

    /* Bundle Children Toggle — event delegation */
    this.addEventListener('click', function(e){
      var btn = e.target.closest('[data-children-toggle]');
      if(!btn) return;
      var list = btn.parentElement.querySelector('[data-children-list]');
      if(!list) return;
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if(isOpen){
        list.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        list.style.display = '';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
